import { useTranslation } from '@/i18n';
import { TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC } from 'react';
import { HeaderSection, SettingItem } from '../Common';
import { OfficeSettingActions } from '../OfficeSettingActions';
import { AI_AGENT_SERVICE_CONTENT_LINK } from './constants';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type AiAgentMainSettingProps = {
  isEnabled: boolean;
  isEditMode: boolean;
};
export const AiAgentMainSetting: FC<AiAgentMainSettingProps> = ({
  isEnabled,
  isEditMode,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx('aiAgentsMainSettingContainer')}>
      <HeaderSection
        displayName={
          <span className={cx('mainSettingDescription')}>
            {t('ai_agents_setting_main_setting_detail_text_prefix')}
            <span>
              <TextLink href={AI_AGENT_SERVICE_CONTENT_LINK} target='_blank'>
                {t('ai_agents_setting_main_setting_service_content_link')}
              </TextLink>
            </span>
            {t('ai_agents_setting_main_setting_detail_text_suffix')}
          </span>
        }
        actionButton={
          <OfficeSettingActions isEnabled={isEnabled} isDisabled={isEditMode} />
        }
      />
      <div className={cx('aiAgentsMainSettingItems')}>
        <SettingItem
          label={t('ai_agents_setting_main_setting_use_setting_label')}
          value={t(isEnabled ? 'use' : 'not_use')}
        />
      </div>
    </div>
  );
};
